import { DialogPlugin } from '../models/dialog-plugin';
import { dressfitModules } from './dressfit/config/dressfit-modules.config';
import { DressfitSupportedModuleIds } from './dressfit/models/dressfit-supported-module-ids';
import { ModuleComponentByModuleId } from './models/module-component-by-module-id';
import { topocareModules } from './topocare/config/topocare-modules.config';
import { TopocareSupportedModuleIds } from './topocare/models/topocare-supported-module-ids';
import { userIdentityModules } from './user-identity/config/user-identity.config';
import { UserIdentitySupportedModuleIds } from './user-identity/models/user-identity-supported-module-ids';
import { woundtrackModules } from './woundtrack/config/woundtrack-modules.config';
import { WoundtrackSupportedModuleIds } from './woundtrack/models/woundtrack-supported-module-ids';

type SupportedModuleIds =
  | WoundtrackSupportedModuleIds
  | TopocareSupportedModuleIds
  | UserIdentitySupportedModuleIds
  | DressfitSupportedModuleIds;

type PluginByModule<T extends keyof ModuleComponentByModuleId> = {
  [M in T]: DialogPlugin<ModuleComponentByModuleId[M]>;
};

export const moduleRegistry: PluginByModule<SupportedModuleIds> = {
  ...woundtrackModules,
  ...topocareModules,
  ...userIdentityModules,
  ...dressfitModules,
};
